const $ = jQuery.noConflict();
import 'select2/dist/js/select2.full.js';
import PSB from './perfectScroll';

'use strict';
const Select2 = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$selectForm: $('.js-select-form'),

	/** @description Initialize */
	init: function() {
		this.select2();
	},

	select2: () => {
		/**
		 * @description Select2 global function
		 * @link Documentation https://select2.org/
		 * @type {object}
		 */

		Select2.select2Positioning();

		Select2.$selectForm.select2({
			minimumResultsForSearch: 3,
			width: 'style',
			dropdownCssClass: '',
			placeholder: 'State',
			dropdownPosition: 'below',
		});

		Select2.$selectForm.on('select2:selecting', function() {
			$('.js-form-select-placeholder').css('opacity', '0');
			PSB.enableScroll();
			$(this).removeClass('wpcf7-not-valid');
			$(this).siblings('.wpcf7-not-valid-tip').remove();
		});

		Select2.$selectForm.on('select2:open', function() {
			PSB.perfectScrollBasicScroll();
			PSB.disableScroll();
			setTimeout(() => {
				PSB.enableScroll();
			}, 50);
		});

		Select2.$selectForm.on('select2:close', function() {
			PSB.enableScroll();
			$('.select2-selection--single').blur();
		});

		$('.select2').on('mouseleave touchend', function() {
			PSB.enableScroll();
		});
	},

	// This adds the option "dropdownPosition" to select2
	select2Positioning: () => {
		const Defaults = $.fn.select2.amd.require('select2/defaults');

		$.extend(Defaults.defaults, {
			dropdownPosition: 'auto'
		});

		const AttachBody = $.fn.select2.amd.require('select2/dropdown/attachBody');
		// const _positionDropdown = AttachBody.prototype._positionDropdown;

		AttachBody.prototype._positionDropdown = function() {

			const $window = $(window);
			const isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
			const isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');
			let newDirection = null;
			const offset = this.$container.offset();

			offset.bottom = offset.top + this.$container.outerHeight(false);

			const container = {
				height: this.$container.outerHeight(false)
			};

			container.top = offset.top;
			container.bottom = offset.top + container.height;

			const dropdown = {
				height: this.$dropdown.outerHeight(false)
			};
			const viewport = {
				top: $window.scrollTop(),
				bottom: $window.scrollTop() + $window.height()
			};
			const enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
			const enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);
			const css = {
				left: offset.left,
				top: container.bottom
			};
			// Determine what the parent element is to use for calciulating the offset
			let $offsetParent = this.$dropdownParent;
			// For statically positoned elements, we need to get the element
			// that is determining the offset
			if ($offsetParent.css('position') === 'static') {
				$offsetParent = $offsetParent.offsetParent();
			}

			const parentOffset = $offsetParent.offset();

			css.top -= parentOffset.top;
			css.left -= parentOffset.left;

			const dropdownPositionOption = this.options.get('dropdownPosition');

			if (dropdownPositionOption === 'above' || dropdownPositionOption === 'below') {
				newDirection = dropdownPositionOption;
			} else {
				if (!isCurrentlyAbove && !isCurrentlyBelow) {
					newDirection = 'below';
				}

				if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
					newDirection = 'above';
				} else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
					newDirection = 'below';
				}
			}

			if (newDirection === 'above' ||
				(isCurrentlyAbove && newDirection !== 'below')) {
				css.top = container.top - parentOffset.top - dropdown.height;
			}

			if (newDirection !== null) {
				this.$dropdown
					.removeClass('select2-dropdown--below select2-dropdown--above')
					.addClass('select2-dropdown--' + newDirection);
				this.$container
					.removeClass('select2-container--below select2-container--above')
					.addClass('select2-container--' + newDirection);
			}

			this.$dropdownContainer.css(css);
		};

	},
};

export default Select2;
